import { WebPlugin } from '@capacitor/core';
export class CapgoInAppReviewWeb extends WebPlugin {
    async requestReview() {
        console.warn('In-App Review is not available on web');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map